// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/icons/close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font {
    font-family: 'Roboto';
    font-weight: normal;
}

.titleText {
    font-size: 96px;
    color: #1faeff;
    margin: 20px 0;
}

.titleText.small {
    font-size: 32px;
    color: #1faeff;
    margin: 4px 10px;
}

.titleText.thin {
    font-weight: normal;
}

.titleText span {
    margin-right: 7px;
}

.paraText {
    font-size: 18px;
    color: #000;
}

.blockLink {
    border: 1px solid #ccc;
    border-radius: 10;
    width: 75%;
    margin: 10px 0;
    padding: 10px 20px 20px 20px;
    text-decoration: none;
    cursor: pointer;
    color: inherit;
}

.tag {
    box-sizing: border-box;
    padding: 2px 8px;
    margin: 2px;
    border-radius: 10px;
    background: #f1f3f4;
    color: black;
    font-size: 16px;
}

.tag:hover {
    background: #d1d2d4;
}

.tag.highlighted {
    border-radius: 30px;
}

.tag.highlighted:hover {
    background: #ff0;
}

.tag.action {
    cursor: pointer;
}

.tag.showCross {
    padding-right: 25px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 13px 13px;
    background-position: calc(100% - 7px) center;
    background-repeat: no-repeat;
}

.titleText .highlighted {
    background: transparent;
    padding: 3px 7px;
    border: 2px solid #1faeff;
}

p .highlighted {
    padding: 2px 7px;
    border-radius: 5px;
}

p span {
    margin-right: 5px;
}

.highlight {
    display: inline;
    background: #ff0;
    padding: 4px 12px;
    border-radius: 10px;
}

[data-entity] {
    padding: 0.25em 0.35em;
    margin: 0px 0.25em;
    line-height: 1;
    display: inline-block;
    border-radius: 0.25em;
    border: 1px solid; 
}

[data-entity]::after {
    box-sizing: border-box;
    font-size: 0.6em;
    line-height: 1;
    padding: 0.35em;
    border-radius: 0.35em;
    text-transform: uppercase;
    display: inline-block;
    vertical-align: middle;
    margin: 0px 0px 0.1rem 0.5rem; 
}

[data-entity][data-entity="highlight"] {
    background: yellow;
    border: none;
}

[data-entity][data-entity="highlight"]::after {
    content: none;
}

[data-entity][data-entity="name"] {
    background: rgba(166, 226, 45, 0.2);
    border-color: rgb(166, 226, 45); 
}

[data-entity][data-entity="name"]::after {
    background: rgb(166, 226, 45); 
    content: attr(data-entity);
}

[data-entity][data-entity="country"] {
    background: rgba(67, 198, 252, 0.2);
    border-color: rgb(67, 198, 252); 
}

[data-entity][data-entity="country"]::after {
    background: rgb(67, 198, 252); 
    content: attr(data-entity);
}

[data-entity][data-entity="commodity"] {
    background: rgba(253, 151, 32, 0.2);
    border-color: rgb(253, 151, 32);
}

[data-entity][data-entity="commodity"]::after {
    background: rgb(253, 151, 32);
    content: attr(data-entity);
}

[data-entity][data-entity\$=" overwrite"] {
    background: rgb(247, 247, 159);
    border-color: yellow;
}

[data-entity][data-entity\$=" overwrite"]::after {
    background: yellow;
}
`, "",{"version":3,"sources":["webpack://./src/Magor/Components/css/Text.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,4BAA4B;IAC5B,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yDAAsD;IACtD,0BAA0B;IAC1B,4CAA4C;IAC5C,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".font {\n    font-family: 'Roboto';\n    font-weight: normal;\n}\n\n.titleText {\n    font-size: 96px;\n    color: #1faeff;\n    margin: 20px 0;\n}\n\n.titleText.small {\n    font-size: 32px;\n    color: #1faeff;\n    margin: 4px 10px;\n}\n\n.titleText.thin {\n    font-weight: normal;\n}\n\n.titleText span {\n    margin-right: 7px;\n}\n\n.paraText {\n    font-size: 18px;\n    color: #000;\n}\n\n.blockLink {\n    border: 1px solid #ccc;\n    border-radius: 10;\n    width: 75%;\n    margin: 10px 0;\n    padding: 10px 20px 20px 20px;\n    text-decoration: none;\n    cursor: pointer;\n    color: inherit;\n}\n\n.tag {\n    box-sizing: border-box;\n    padding: 2px 8px;\n    margin: 2px;\n    border-radius: 10px;\n    background: #f1f3f4;\n    color: black;\n    font-size: 16px;\n}\n\n.tag:hover {\n    background: #d1d2d4;\n}\n\n.tag.highlighted {\n    border-radius: 30px;\n}\n\n.tag.highlighted:hover {\n    background: #ff0;\n}\n\n.tag.action {\n    cursor: pointer;\n}\n\n.tag.showCross {\n    padding-right: 25px;\n    background-image: url(../../../assets/icons/close.svg);\n    background-size: 13px 13px;\n    background-position: calc(100% - 7px) center;\n    background-repeat: no-repeat;\n}\n\n.titleText .highlighted {\n    background: transparent;\n    padding: 3px 7px;\n    border: 2px solid #1faeff;\n}\n\np .highlighted {\n    padding: 2px 7px;\n    border-radius: 5px;\n}\n\np span {\n    margin-right: 5px;\n}\n\n.highlight {\n    display: inline;\n    background: #ff0;\n    padding: 4px 12px;\n    border-radius: 10px;\n}\n\n[data-entity] {\n    padding: 0.25em 0.35em;\n    margin: 0px 0.25em;\n    line-height: 1;\n    display: inline-block;\n    border-radius: 0.25em;\n    border: 1px solid; \n}\n\n[data-entity]::after {\n    box-sizing: border-box;\n    font-size: 0.6em;\n    line-height: 1;\n    padding: 0.35em;\n    border-radius: 0.35em;\n    text-transform: uppercase;\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0px 0px 0.1rem 0.5rem; \n}\n\n[data-entity][data-entity=\"highlight\"] {\n    background: yellow;\n    border: none;\n}\n\n[data-entity][data-entity=\"highlight\"]::after {\n    content: none;\n}\n\n[data-entity][data-entity=\"name\"] {\n    background: rgba(166, 226, 45, 0.2);\n    border-color: rgb(166, 226, 45); \n}\n\n[data-entity][data-entity=\"name\"]::after {\n    background: rgb(166, 226, 45); \n    content: attr(data-entity);\n}\n\n[data-entity][data-entity=\"country\"] {\n    background: rgba(67, 198, 252, 0.2);\n    border-color: rgb(67, 198, 252); \n}\n\n[data-entity][data-entity=\"country\"]::after {\n    background: rgb(67, 198, 252); \n    content: attr(data-entity);\n}\n\n[data-entity][data-entity=\"commodity\"] {\n    background: rgba(253, 151, 32, 0.2);\n    border-color: rgb(253, 151, 32);\n}\n\n[data-entity][data-entity=\"commodity\"]::after {\n    background: rgb(253, 151, 32);\n    content: attr(data-entity);\n}\n\n[data-entity][data-entity$=\" overwrite\"] {\n    background: rgb(247, 247, 159);\n    border-color: yellow;\n}\n\n[data-entity][data-entity$=\" overwrite\"]::after {\n    background: yellow;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
